import React from 'react';
import { Star } from 'lucide-react';
import { Section } from './Shared';
export interface TestimonialProps {
  initials: string;
  name: string;
  location: string;
  text: string;
  product?: string;
}
export const TestimonialCard = ({
  initials,
  name,
  location,
  text,
  product
}: TestimonialProps) => <div className="glass-panel p-6 md:p-8 rounded-2xl flex flex-col h-full pl-[15px] pr-[15px] pt-[1px] pb-[1px]" data-id="element-358">
    <div className="flex items-center mb-4" data-id="element-359">
      <div className="w-9 h-9 md:w-12 md:h-12 rounded-full bg-brand-surfaceLight flex items-center justify-center text-brand-gold font-serif font-bold text-sm md:text-xl border border-brand-pink/30 mr-3 md:mr-4 shrink-0" data-id="element-360">
        {initials}
      </div>
      <div data-id="element-361">
        <div className="flex text-brand-gold mb-1 text-[15px]" data-id="element-362">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-363" />)}
        </div>
        <div className="font-medium text-brand-text" data-id="element-364">{name}</div>
        <div className="text-xs text-brand-muted" data-id="element-365">
          {location} {product && `— ${product}`}
        </div>
      </div>
    </div>
    <p className="text-brand-text/90 italic flex-grow text-[13px]" data-id="element-366">"{text}"</p>
  </div>;
export const InitialTestimonials = () => {
  const testimonials = [{
    initials: 'MG',
    name: 'Marcela G.',
    location: 'Córdoba',
    text: 'Empecé el Tomo 1 un lunes. El viernes ya había pagado una deuda que tenía hacía 8 meses. Algo cambió en mi cabeza.'
  }, {
    initials: 'LP',
    name: 'Laura P.',
    location: 'Rosario',
    text: 'Los decretos me parecían cosa de libros rosados hasta que empecé a registrar mis sincronías. En 30 días llegaron 3 clientes nuevos sin buscarlos.'
  }, {
    initials: 'RM',
    name: 'Roberto M.',
    location: 'Buenos Aires',
    text: 'El Tomo 4 me ayudó a armar mi primer presupuesto consciente. Por primera vez en años, sé adónde va cada peso.'
  }];
  return <Section className="pt-8 pb-16" data-id="element-367">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-[12px]" data-id="element-368">
        {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-369" />)}
      </div>
    </Section>;
};
export const ExtendedTestimonials = () => {
  const testimonials = [{
    initials: 'CR',
    name: 'Cecilia R.',
    location: 'Mendoza',
    product: 'MegaPack Completo',
    text: 'El Tomo 2 me hizo llorar. Había creencias sobre el dinero que cargaba desde mi infancia y ni sabía que estaban ahí. Cuando las dissolví, algo se abrió de verdad.'
  }, {
    initials: 'DM',
    name: 'Diego M.',
    location: 'Tucumán',
    product: 'MegaPack + Instante Abundante',
    text: 'En la semana 2 ya noté que mi cabeza funcionaba diferente. Dejé de tomar decisiones financieras desde el miedo. Eso solo ya valió lo que pagué.'
  }, {
    initials: 'RM',
    name: 'Roberto M.',
    location: 'Buenos Aires',
    product: 'MegaPack + Instante Abundante',
    text: 'Soy contador y soy escéptico de la espiritualidad. Pero las herramientas financieras del Tomo 4 son sólidas y el componente energético le da una dimensión que los libros de finanzas nunca tienen.'
  }, {
    initials: 'SB',
    name: 'Sofía B.',
    location: 'La Plata',
    product: 'MegaPack Código de Abundancia',
    text: 'En el mes 3 llegó un cliente que me pagó más de lo que ganaba en todo el mes anterior. Yo sé que fue porque algo cambió adentro mío.'
  }];
  return <Section className="bg-brand-surfaceLight/50 rounded-3xl my-16" data-id="element-370">
      <div className="text-center mb-12" data-id="element-371">
        <h2 className="text-3xl md:text-4xl font-serif font-bold mb-4" data-id="element-372">
          ❤️ MÁS PERSONAS QUE YA TRANSFORMARON SU REALIDAD
        </h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-373">
        {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-374" />)}
      </div>
    </Section>;
};